var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ViewInsurances } from "./view";
import LocalStorageService from "../../services/localStorage";
import { project, projectClearData } from "../../store/project/actions";
import { sponsor } from "../../store/sponsor/actions";
import { deleteEntity } from "../../store/delete/actions";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { themeCore } from "../../assets/themes/theme";
import { GetInsurancesTypes } from "../../fnx/insurances/getInsurancesTypes";
import { useNavigate } from "react-router-dom";
import { showErrorToast } from "../../fnx/showError";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { useTranslation } from "react-i18next";
import { GetProjectAll } from "../../fnx/project/projectAll";
import { hasPermission } from "../../services/getNavigationPages";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var InsurancesAdmin = function () {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var navigate = useNavigate();
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var limit = React.useState(1000)[0];
    var _c = React.useState([]), insurancesList = _c[0], setInsurancesList = _c[1];
    var _d = React.useState([]), insuranceTypeList = _d[0], setInsuranceTypeList = _d[1];
    var _e = useState([]), insuranceTypeOptions = _e[0], setInsuranceTypeOptions = _e[1];
    var _f = useState([]), sponsorOptions = _f[0], setSponsorOptions = _f[1];
    var _g = React.useState([]), sponsorList = _g[0], setSponsorList = _g[1];
    var _h = React.useState(false), openModal = _h[0], setOpenModal = _h[1];
    var _j = useState(false), openModalConfirmClone = _j[0], setOpenModalConfirmClone = _j[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _k = React.useState(""), sponsorsIds = _k[0], setSponsorsIds = _k[1];
    var _l = React.useState(false), trigger = _l[0], setTrigger = _l[1];
    var _m = React.useState(false), triggerProject = _m[0], setTriggerProject = _m[1];
    var _o = React.useState(null), itemModal = _o[0], setitemModal = _o[1];
    var _p = React.useState(""), nameSearch = _p[0], setNameSearch = _p[1];
    var _q = React.useState(null), filtersItem = _q[0], setFiltersItem = _q[1];
    var _r = useState(1), insurancePage = _r[0], setInsurancePage = _r[1];
    var _s = useState(20), insuranceLimit = _s[0], setInsuranceLimit = _s[1];
    var _t = useState(0), countPagination = _t[0], setCountPagination = _t[1];
    var _u = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _u[0], setSeeToast = _u[1];
    var _v = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToastSuccess = _v[0], setSeeToastSuccess = _v[1];
    var permissions = {
        create: hasPermission("admin-product-create"),
        read: hasPermission("admin-product-view"),
        update: hasPermission("admin-product-edit"),
        delete: hasPermission("admin-product-delete"),
        clone: hasPermission("admin-product-clone"),
        detail: true, //hasPermission("admin-produt-view-details"),
    };
    var _w = useState(false), openModalConfirmDelete = _w[0], setOpenModalConfirmDelete = _w[1];
    var _x = useState({ id: "", title: "" }), itemCard = _x[0], setItemCard = _x[1];
    var _y = GetInsurancesTypes(trigger, enable, page, limit, clientId), responseInsuranceType = _y.responseInsuranceType, errorInsuranceType = _y.errorInsuranceType, loadingInsuranceType = _y.loadingInsuranceType;
    var _z = useSelector(function (state) {
        var _a;
        return ({
            responseSponsor: (_a = state.Sponsor.responseSponsor) === null || _a === void 0 ? void 0 : _a.data,
            errorSponsor: state.Sponsor.errorSponsor,
            loadingSponsor: state.Sponsor.loadingSponsor,
        });
    }), responseSponsor = _z.responseSponsor, errorSponsor = _z.errorSponsor, loadingSponsor = _z.loadingSponsor;
    var _0 = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _0.responseDeleteEntity, loadingDeleteEntity = _0.loadingDeleteEntity, errorDeleteEntity = _0.errorDeleteEntity;
    var _1 = GetProjectAll(triggerProject, enable, insurancePage, insuranceLimit, sponsorsIds), responseProject = _1.responseProject, errorProject = _1.errorProject, loadingProject = _1.loadingProject;
    useEffect(function () {
        dispatch(sponsor({
            enable: enable,
            page: page,
            limit: limit,
            clientId: clientId,
        }));
        setTrigger(true);
    }, []);
    useEffect(function () {
        if (errorProject) {
            showErrorToast(errorProject, setSeeToast, t);
        }
    }, [errorProject]);
    useEffect(function () {
        if (errorSponsor) {
            showErrorToast(errorSponsor, setSeeToast, t);
        }
    }, [errorSponsor]);
    useEffect(function () {
        if (errorInsuranceType) {
            showErrorToast(errorInsuranceType, setSeeToast, t);
        }
    }, [errorInsuranceType]);
    // busqueda por nombre
    useEffect(function () {
        if (nameSearch) {
            getInsurances();
        }
        else {
            onCloseSearch();
        }
    }, [nameSearch]);
    //Llena la data para el filtro tipo de producto
    useEffect(function () {
        var _a;
        if (responseInsuranceType && ((_a = responseInsuranceType === null || responseInsuranceType === void 0 ? void 0 : responseInsuranceType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var newInsurancesTypeList = responseInsuranceType.data.map(function (item) { return ({
                id: item.id,
                name: item.description,
                value: item.id,
                active: false,
            }); });
            setInsuranceTypeList(newInsurancesTypeList);
        }
        if (Array.isArray(responseInsuranceType)) {
            setInsuranceType(responseInsuranceType);
        }
    }, [responseInsuranceType]);
    //Llena la data para el filtro de los sponsor
    useEffect(function () {
        if (responseSponsor && (responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.length) > 0) {
            var newSponsorList = responseSponsor.map(function (item) { return ({
                id: item.id,
                name: item.name,
                value: item.id,
                active: false,
            }); });
            setSponsorList(newSponsorList);
            var idSponsor = responseSponsor
                .map(function (item) { return item.id; })
                .join("&sponsorId=");
            setSponsorsIds(idSponsor);
            setTriggerProject(true);
        }
        if (Array.isArray(responseSponsor)) {
            setSponsors(responseSponsor);
        }
    }, [responseSponsor]);
    //Llena la data para las card
    useEffect(function () {
        if (responseProject) {
            var newInsurancesList = responseProject.data.map(function (item) { return (__assign(__assign({}, item), { id: item.id, title: item.description, logoUrl: item.logoUrl })); });
            setInsurancesList(newInsurancesList);
        }
        if (responseProject === null || responseProject === void 0 ? void 0 : responseProject.pagingInfo) {
            setCountPagination(responseProject === null || responseProject === void 0 ? void 0 : responseProject.pagingInfo.totalItems);
        }
    }, [responseProject]);
    useEffect(function () {
        if (responseDeleteEntity) {
            showToastSuccessMessage("Producto eliminado con éxito.", typeAlert.success, setSeeToastSuccess);
            filterStatus(filtersItem);
            dispatch(projectClearData());
        }
        else if (errorDeleteEntity) {
            showErrorToast(errorDeleteEntity, setSeeToast, t);
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    var setInsuranceType = function (responseInsuranceType) {
        var dataBranches = [];
        responseInsuranceType === null || responseInsuranceType === void 0 ? void 0 : responseInsuranceType.map(function (item) {
            if (item.id && item.description) {
                dataBranches.push({
                    id: item.id,
                    name: item.description,
                    active: false,
                });
            }
        });
        setInsuranceTypeOptions(dataBranches);
    };
    var setSponsors = function (responseSponsor) {
        var dataBranches = [];
        responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.map(function (item) {
            if (item.id && item.name) {
                dataBranches.push({
                    id: item.id,
                    name: item.name,
                    active: false,
                });
            }
        });
        setSponsorOptions(dataBranches);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOpenModalConfirm = function () {
        // setOpenModalConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var productCreation = function () {
        navigate("/product-creation");
    };
    var showImage = function (url) { };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleDelete = function (item) {
        var _a;
        if (item) {
            setOpenModalConfirmDelete(false);
            if (item.campaign.length > 0 &&
                Object.keys(item.campaign[0]).length > 0) {
                dispatch(deleteEntity({
                    id: (_a = item.campaign[0]) === null || _a === void 0 ? void 0 : _a.id,
                    entity: "CampaignEntity",
                    idUser: clientId,
                }));
                dispatch(deleteEntity({
                    id: item.id,
                    entity: "ProjectEntity",
                    idUser: clientId,
                }));
            }
            else {
                dispatch(deleteEntity({
                    id: item.id,
                    entity: "ProjectEntity",
                    idUser: clientId,
                }));
            }
        }
    };
    var handleClone = function () {
        var body = {
            clientId: itemModal.clientId,
            name: itemModal.title,
        };
        setOpenModal(false);
        setOpenModalConfirmClone(false);
    };
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    var onCloseSearch = function () {
        if (sponsorList.length > 0) {
            setNameSearch("");
            dispatch(project({
                enable: enable,
                page: insurancePage,
                limit: insuranceLimit,
                sponsorId: sponsorsIds,
                description: "",
            }));
        }
    };
    var seeDetailsProduct = function (item) {
        navigate("/product-creation/".concat(item.id));
    };
    var editProduct = function (product) {
        navigate("/product-creation/".concat(product.id, "/true"));
    };
    var getInsurances = function () {
        dispatch(project({
            enable: enable,
            page: insurancePage,
            limit: insuranceLimit,
            sponsorId: sponsorsIds,
            description: nameSearch,
        }));
    };
    var filterStatus = function (item) {
        if (sponsorList.length > 0) {
            setFiltersItem(item);
            var idInsuranceType = item === null || item === void 0 ? void 0 : item.insurance.map(function (item) { return item.id; }).join("&projectType=");
            var idSponsor = item === null || item === void 0 ? void 0 : item.sponsor.map(function (item) { return item.id; }).join("&sponsorId=");
            dispatch(projectClearData());
            dispatch(project({
                enable: enable,
                page: insurancePage,
                limit: insuranceLimit,
                projectType: idInsuranceType,
                sponsorId: idSponsor ? idSponsor : sponsorsIds,
            }));
        }
    };
    var optionProduct = function (op, product) {
        switch (op.id) {
            case "1":
                navigate("/product-creation/".concat(product.id, "/true/true"));
                break;
            case "2":
                editProduct(product);
                break;
            case "3":
                setOpenModalConfirmClone(true);
                break;
            case "4":
                setOpenModalConfirmDelete(true);
                setItemCard(product);
                break;
        }
    };
    var onChangePage = function (e) {
        setInsurancePage(e);
        setTriggerProject(true);
    };
    var onChangeRowsPerPage = function (e) {
        setInsuranceLimit(e);
        setTriggerProject(true);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(LoadingAFY, { loading: loadingProject || loadingDeleteEntity, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: loadingDeleteEntity ? "Eliminando producto" : "Cargando productos...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({ show: false, message: "", type: typeAlert.success });
                }), seeToastSuccess.show &&
                showToast(position.bottomRight, seeToastSuccess.type, seeToastSuccess.message, function () {
                    setSeeToastSuccess({
                        show: false,
                        message: "",
                        type: typeAlert.success,
                    });
                }), _jsx(ViewInsurances, { permissions: permissions, onCloseSearch: onCloseSearch, searchFilter: searchFilter, filterStatus: filterStatus, insuranceTypeOptions: insuranceTypeOptions, sponsorOptions: sponsorOptions, insurancesList: insurancesList, insuranceTypeList: insuranceTypeList, sponsorList: sponsorList, titlePage: "Productos", openModal: openModal, openModalConfirmDelete: openModalConfirmDelete, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, clickView: clickView, onSubmitClone: handleClone, onClose: handleCloseModal, handleOpenModal: handleOpenModal, handleOpenModalConfirm: handleOpenModalConfirm, onClickAdd: productCreation, onUpload: function (url) {
                    showImage(url);
                }, setOpenModalConfirmDelete: setOpenModalConfirmDelete, optionProduct: optionProduct, itemCard: itemCard, onClickDelete: handleDelete, onClickDetails: seeDetailsProduct, openModalConfirmClone: openModalConfirmClone, setOpenModalConfirmClone: setOpenModalConfirmClone, insurancePage: insurancePage, insuranceLimit: insuranceLimit, countPagination: countPagination, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage })] }));
};
export default InsurancesAdmin;
